document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-about-essence]');
    if (!section) return;

    var panels = section.querySelectorAll('[data-essence-panel]');
    var buttons = section.querySelectorAll('[data-essence-tab]');

    function setActivePanel(key) {
        panels.forEach(function (panel) {
            var isMatch = panel.getAttribute('data-essence-panel') === key;
            panel.classList.toggle('is-active', isMatch);
        });

        buttons.forEach(function (button) {
            var isMatch = button.getAttribute('data-essence-tab') === key;
            button.classList.toggle('is-active', isMatch);
            button.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            var key = button.getAttribute('data-essence-tab');
            if (!key) return;
            setActivePanel(key);
        });
    });
});